import { render } from "./Base-Notification.vue?vue&type=template&id=0af08c52"
import script from "./Base-Notification.vue?vue&type=script&lang=js"
export * from "./Base-Notification.vue?vue&type=script&lang=js"

import "./Base-Notification.vue?vue&type=style&index=0&id=0af08c52&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__